export default __webpack_public_path__ + "static/media/coins.a4c7194d.png";